// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import * as React from "react"

export const UnnamedGlobalGroupOfVariantsContext = React.createContext(
  "PLEASE_RENDER_INSIDE_PROVIDER"
)

export default UnnamedGlobalGroupOfVariantsContext
/* prettier-ignore-end */
